// extracted by mini-css-extract-plugin
export default {"tag":"style_tag__4oAa-","success":"style_success__CY3K5","error":"style_error__fFQ1r","warning":"style_warning__sl+Lz"};